// Friends: API calls and the counter of received requests (shown in the navigation).
import type { FriendsResponse, FriendRequestResponse, UserSearchResult, FeedItem, FriendsPresenceResponse } from '@gruvetto/contracts';
import { api, isLoggedIn, onAuthChange } from './api.js';

let incoming = 0;
const listeners = new Set<(n: number) => void>();
const setIncoming = (n: number) => { if (n !== incoming) { incoming = n; for (const fn of listeners) fn(n); } };

export const incomingCount = () => incoming;
export function onFriendsChange(fn: (incoming: number) => void) { listeners.add(fn); return () => listeners.delete(fn); }

export async function loadFriends(): Promise<FriendsResponse> {
  const r = await api<FriendsResponse>('/friends');
  setIncoming(r.incoming.length);
  return r;
}
export const searchUsers = (q: string) => api<UserSearchResult[]>('/users/search?q=' + encodeURIComponent(q));
export const sendRequest = (target: { code: string } | { userId: string }) => api<FriendRequestResponse>('/friends/requests', { method: 'POST', body: target });
export const acceptRequest = (userId: string) => api(`/friends/${userId}/accept`, { method: 'POST' });
/** Removes a friend, declines a received request or cancels a sent one. */
export const removeFriend = (userId: string) => api(`/friends/${userId}`, { method: 'DELETE' });
export const friendsFeed = () => api<FeedItem[]>('/friends/feed');
/** Which friends are in an online room right now (for "watch a friend"). */
export const friendsPresence = () => api<FriendsPresenceResponse>('/friends/presence');

/** Invitation link: opens the Friends screen and sends the request to the code's owner. */
export const inviteLink = (code: string) => `${location.origin}${location.pathname}#/friends/add/${encodeURIComponent(code)}`;

/** Refreshes the counter in the background (on sign-in, then every two minutes). */
export function watchFriendRequests() {
  const poll = () => { if (isLoggedIn() && document.visibilityState !== 'hidden') loadFriends().catch(() => {}); else if (!isLoggedIn()) setIncoming(0); };
  onAuthChange(poll);
  setInterval(poll, 120_000);
  poll();
}
